<template>
    <a :href="trailer.url" class="search-result-card">
        <div class="search-result-card__image-wrap">
            <img
                v-if="trailer.imageUrl"
                :src="trailer.imageUrl"
                :alt="trailer.imageAlt || trailer.title"
                :title="trailer.imageTitle || undefined"
                class="search-result-card__image"
                loading="lazy"
            />
            <div v-else class="search-result-card__image-placeholder">
                <BaseIcon name="ri-truck-line" />
            </div>
        </div>
        <div class="search-result-card__body">
            <span class="search-result-card__category">{{ trailer.category }}</span>
            <h4 class="search-result-card__title">{{ trailer.title }}</h4>
            <p class="search-result-card__reason">{{ trailer.reason }}</p>
            <div class="search-result-card__specs">
                <span v-if="trailer.payload_kg" class="search-result-card__spec">
                    <BaseIcon name="ri-weight-line" /> {{ trailer.payload_kg }} kg
                </span>
                <span v-if="trailer.length_cm && trailer.width_cm" class="search-result-card__spec">
                    <BaseIcon name="ri-ruler-line" /> {{ trailer.length_cm }}×{{ trailer.width_cm }} cm
                </span>
                <span v-if="trailer.has_cover" class="search-result-card__spec">
                    <BaseIcon name="ri-shield-check-line" /> Mit Plane
                </span>
            </div>
            <div v-if="trailer.price" class="search-result-card__price">
                ab {{ trailer.price }} € <small>{{ trailer.priceLabel }}</small>
            </div>
        </div>
    </a>
</template>

<script setup>
import BaseIcon from "./BaseIcon.vue";
defineProps({
    trailer: {
        type: Object,
        required: true,
    },
})
</script>
